export default {"src":"/_next/static/media/background1.1a59be74.svg","height":189,"width":181};